module.exports = __webpack_public_path__ + "static/media/perretti-website.031b06f2.png";